import { useMutation, useQueryClient } from 'react-query'
import { BASE_API_URL } from 'constants/env'
import { API_METHODS } from 'constants/api-methods'
import { apiHeaders } from 'utils/api-headers'
import { store } from 'index'
import { handleErrors } from 'utils/handle-errors'
import toast from 'react-hot-toast'

interface UpdateAnsibleParams {
  ansibleId: string
  maxMacMinis?: number
  maxPhysicalPhones?: number
  currentMacMinis?: number
  currentPhysicalPhones?: number
  name?: string
  status?: string
}

const updateAnsible = async ({
  ansibleId,
  ...updateData
}: UpdateAnsibleParams) => {
  let response = await fetch(
    `${BASE_API_URL}/api/v4/phone_number_service/ansibles/${ansibleId}`,
    {
      method: API_METHODS.PUT,
      headers: apiHeaders(store.getState()),
      body: JSON.stringify(updateData),
    }
  )

  response = handleErrors(response)
  return response.json()
}

const useUpdateAnsible = () => {
  const queryClient = useQueryClient()

  return useMutation(updateAnsible, {
    onError: (error: Error) => {
      console.error('Failed to update ansible:', error)
      toast.error(`Failed to update ansible: ${error.message}`)
    },
    onSuccess: (data, variables) => {
      toast.success('Ansible updated successfully')

      // Invalidate related queries
      queryClient.invalidateQueries(['ansible-detail', variables.ansibleId])
      queryClient.invalidateQueries(['ansibles'])
      queryClient.invalidateQueries(['available-ansibles'])
      queryClient.invalidateQueries(['terminal-detail'])
    },
  })
}

export default useUpdateAnsible
